<template>
    <header class="header">
        <a href="/">
            <div class="logo">
                <img src="@/assets/logo_DOUBLE_SCOOP_REBATE.svg" alt="Logo" />
            </div>
        </a>
    </header>
</template>

<script>

import isMobile from 'ismobilejs';
export default {
    name: 'Header',
    data() {
        return {
            isPlayerLoaded: false
        };
    },
    computed: {
        isMobile() {
            return isMobile().any;
        }
    },
    mounted() {

    }
};
</script>

<style lang="scss">
.opaque {
    opacity: 0 !important;
}

.header {
    .logo {
        display: block;
        text-align: center;
        margin: $gap * 2 $gap;
        min-height: 46px;
        max-height: 100px;
        
        img {
          height: 10vw;
          min-height: 50px;
          max-height: 100px;
        }
    }

    cursor: pointer;
}
</style>
